export default __webpack_public_path__ + "static/media/stake-inactive.da66a484.svg";